<template>
  <div ref="svgDiv"></div>
</template>

<script>
export default {
  name: 'SVGIcon',
  props: {
    svg: { type: String, required: true },
  },
  data() {
    return {
      svgEl: null,
    }
  },
  async mounted() {
    try {
      const res = await fetch(this.svg)
      const svg = await res.text()
      const el = document.createElement('div')
      el.innerHTML = svg
      const svgEl = el.querySelector('svg')
      const host = this.$refs.svgDiv
      if (!host || !svgEl) {
        this.$emit('doneRender')
        return
      }
      host.appendChild(svgEl)
      this.svgEl = svgEl
      this.$emit('doneRender')
    } catch (err) {
      console.error('[SVGIcon] failed to load SVG', err)
      this.$emit('doneRender')
    }
  },
}
</script>

<style></style>
